<template>
  <div class="tooltip-wrapper">
    <span class="tooltip-text" v-bind:class="[!text ? 'hide-tooltip' : '']" v-html="text"></span>
    <slot><i class="far fa-question-circle tooltip-icon"></i></slot>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
  },
};
</script>
<style>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-wrapper .tooltip-text {
  visibility: hidden;
  position: absolute;
  bottom: 1.5rem;
  border: 1px solid #f1f1f1;
  background: #f1f1f1;
  padding: 8px;
  border-radius: 6px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 500px;
  min-width: 150px;
  width: auto;
  overflow-wrap: break-word;
}

.tooltip-wrapper:hover .tooltip-text,
.tooltip-wrapper:hover .tooltip-arrow {
  visibility: visible;
}

.tooltip-wrapper:hover .tooltip-text.hide-tooltip,
.tooltip-wrapper:hover .tooltip-arrow.hide-tooltip {
    visibility: hidden;
}

.tooltip-text::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #f1f1f1 transparent transparent transparent;
}

.tooltip-icon {
  font-size: 18px;
}

@media only screen and (max-width: 600px) {
  .fa-question-circle {
    margin-left: 5px;
  }
}
</style>
